import { Bug, Sparkle } from "@phosphor-icons/react";
import { ItemType } from "shared/types/bug-report";
import { PickerItemProps } from "../../types";

export const BugTypeItem = ({ item, isSelected, onSelect }: PickerItemProps<ItemType>) => {
  const getTypeIcon = (type: ItemType) => {
    return type === ItemType.BUG ? Bug : Sparkle;
  };

  const getTypeColor = (type: ItemType) => {
    return type === ItemType.BUG
      ? "bg-brick-primary/10 text-brick-primary border-brick-primary/30"
      : "bg-blue-100 text-blue-700 border-blue-300";
  };

  const TypeIcon = getTypeIcon(item);

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <TypeIcon className="h-4 w-4" weight="duotone" />
        <div className={`px-2 py-1 rounded-md border text-xs font-medium ${getTypeColor(item)}`}>
          {item === ItemType.BUG ? '🐛 Bug' : '✨ Feature'}
        </div>
      </div>
    </button>
  );
};
